   <template>
    <div class="flex mx-8 justify-between items-center mt-4 text-[13px]">
      <!-- Previous Button -->
      <p
        @click="$emit('changePage', currentPage - 1)"
        :class="['flex items-center gap-2 py-2 rounded', currentPage === 1 ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer']"
      >
        <img src="@/assets/reports/arrow-left.svg" alt="Chevron icon" class="h-4" />
        Previous
      </p>
      <!-- Page Numbers with Ellipsis -->
      <div class="flex gap-2">
        <span 
          v-for="page in visiblePages" 
          :key="page"
          @click="page !== '...' && $emit('changePage', page)"
          :class="[ 
            'px-4 py-2 rounded cursor-pointer',
            page === currentPage ? 'bg-[#EFF4FF] text-grayDark' : 'hover:bg-grayDark hover:text-primaryLight',
            page === '...' ? 'cursor-default' : ''
          ]"
        >
          {{ page }}
        </span>
      </div>
  
      <!-- Next Button -->
      <p
        @click="$emit('changePage', currentPage + 1)"
        :class="['flex items-center gap-2 py-2 rounded', currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer']"
      >
        Next
        <img src="@/assets/reports/arrow-right.svg" alt="Chevron icon" class="h-4" />
      </p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PaginationComponent',
    props: {
      currentPage: {
        type: Number,
        required: true,
      },
      totalPages: {
        type: Number,
        required: true,
      },
    },
    computed: {
      visiblePages() {
        const pages = [];
        // const maxVisible = 7; // Max pages displayed (excluding ellipsis)
  
        if (this.totalPages <= 10) {
          return Array.from({ length: this.totalPages }, (_, i) => i + 1);
        }
  
        if (this.currentPage <= 4) {
          pages.push(1, 2, 3, 4, 5, '...', this.totalPages);
        } else if (this.currentPage >= this.totalPages - 3) {
          pages.push(1, '...', this.totalPages - 4, this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages);
        } else {
          pages.push(1, '...', this.currentPage - 1, this.currentPage, this.currentPage + 1, '...', this.totalPages);
        }
  
        return pages;
      }
    }
  };
  </script>
  
  <style scoped>
  /* Add custom styles if needed */
  </style>
  